import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddParentTaskWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
// import AddParentTaskIcon from '../assets/images/task-group-icon.svg';
import AddParentTaskIcon from '../assets/images/add-task-group-new-icon.svg';
import { withRouter } from 'react-router';
import AddRelatedTaskForm from '../forms/add_related_task_form/AddRelatedTaskForm';
import {
  addRelatedTasks,
  readTask,
  addParentTaskByLevel,
} from '../redux/actions/table/all_tasks';
import { setNotification } from '../redux/actions/general/notification';
import AddParentTaskForm from '../forms/add_parent_task_wizard/AddParentTaskForm';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'all_tasks'),
}))
@withRouter
class AddParentTaskWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    if (!formData?.task_group_id || !formData?.selection_level) {
      setNotification(__('general.error-something-went-wrong'));
      return Promise.resolve();
    }

    return validateForm(
      addParentTaskByLevel(this.props.store.add_parent_task_wizard, formData)
        .then((response) => {
          readTask(this.props.store.add_parent_task_wizard).then(() => {
            if (this.props.match.path == '/meetings/:meeting') {
              setTableParams('all_tasks', {
                clicked_row: this.props.store.add_parent_task_wizard,
              });
            }

            setNotification(
              __(
                'wizard.tasks.all-tasks.flyout.parent-tasks.subtitle.parent-task-added',
              ),
            );

            this.props.onClose();
          });
        })
        .catch((error) => {
          console.error(error);

          const status = error?.status;

          // setNotification(__('general.error-something-went-wrong'));
          if (status === 422) setNotification(error?.response?.error);
        }),
    );
  }

  render() {
    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>
              {__(
                'wizard.tasks.all-tasks.flyout.parent-tasks.title.add-parent-task',
              )}
            </span>
            <span>
              {__(
                'wizard.tasks.all-tasks.flyout.parent-tasks.subtitle.add-parent-task',
              )}
            </span>
          </div>
          <div className={styles.right}>
            <AddParentTaskIcon />
          </div>
        </div>
        <div className={styles.body}>
          <AddParentTaskForm
            onSubmit={this._handleSubmit}
            initialValues={{
              task_ids: [],
            }}
          />
        </div>
      </>
    );
  }
}

export default AddParentTaskWizard;
